import React from 'react';
import JustificationContainer, {
  type Props as JustificationContainerProps,
} from '~/components/atom/JustificationContainer';

const SectionContainer: React.FCC<JustificationContainerProps> = ({
  children,
  ...rest
}) => (
  <JustificationContainer direction="column" width="100%" {...rest}>
    {children}
  </JustificationContainer>
);

export default SectionContainer;
